import * as Styled from "./EventFeedbackSuccessModal.styles";

import { Box, Typography } from "@mui/material";

import BaseModal from "../BaseModal/BaseModal";
import { FeedbackSuccess } from "../../assets";

type EventFeedbackSuccessModalProps = {
  open: any;
  onClose: any;
};

const EventFeedbackSuccessModal = ({ open, onClose }: EventFeedbackSuccessModalProps) => {
  return (
    <BaseModal open={open} onClose={onClose} desktopWidth={"auto"} showCloseButton={true}>
      <Styled.ModalContainer>
        <Box sx={{display: "flex", marginTop: "30px", justifyContent: "center"}}>
          <Styled.SuccessImage src={FeedbackSuccess} alt="success-heart-logo" />
        </Box>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", rowGap: "10px"}}>
          <Typography variant="h2">Thanks for the feedback!</Typography>
          <Typography variant="modalBody">We appreciate your participation, and looking forward to hearing from you on the next event.</Typography>
        </Box>
      </Styled.ModalContainer>
    </BaseModal>
  );
};

export default EventFeedbackSuccessModal;
